<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5">{{NAT_NAME_KR}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">Factory</th>
                               <td class="tableLinerT text-left pl-5">{{FAC_NAME_KR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Model</th>
                               <td class="text-left pl-5">{{EBK_MODEL_NAME}}</td>
                               <th class="listHeader" >Vehicle Identification Number</th>
                               <td class="text-left pl-5">{{EBK_IDTFY_NUMS}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Registered User</th>
                               <td class="text-left pl-5">{{INS_USR}}</td>
                               <th class="listHeader">Approval User</th>
                               <td class="text-left pl-5">{{APRV_USR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Status</th>
                               <td class="tableLinerB text-left pl-5">{{APRV_INFO}}</td>
                               <th class="listHeader tableLinerB">Registration Date</th>
                               <td class="tableLinerB text-left pl-5">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Device Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader text-center" style="width:20%">Device</th>
                                    <th class="listHeader text-center" style="width:20%">ID</th>
                                    <th class="listHeader text-center">Memo</th>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerB text-left pl-5">VCU ID</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5">{{VCU_ID}}</td>
                                    <td class="tableLinerB">{{CONT1}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerB text-left pl-5">MCU ID</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5">{{MCU_ID}}</td>
                                    <td class="tableLinerB">{{CONT2}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerB text-left pl-5">Battery ID 1</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5">{{CELL_ID1}}</td>
                                    <td class="tableLinerB">{{CONT3}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerB text-left pl-5">Battery ID 2</th>
                                    <td class="tableLinerR tableLinerB text-left pl-5">{{CELL_ID2}}</td>
                                    <td class="tableLinerB">{{CONT4}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <div class="d-flex flat ">
                            <div class="mr-auto align-self-center"><h3>History</h3></div>
                            <div ><v-btn icon color="primary" @click="regOpenHistory"><v-icon>mdi-pencil-plus</v-icon></v-btn></div>
                        </div>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader text-center" style="width:20%;">Date</th>
                                    <th class="listHeader tableLinerR text-center">Memo</th>
                                </tr>
                                <tr v-for="(item) in historyList" :key="item.HIS_SEQ">
                                    <td class="rowList tableLinerR tableLinerB">{{item.INS_DTM}}</td>
                                    <td class="rowList tableLinerB text-left pl-5">{{item.CONT}}</td>
                                </tr>
                                <tr v-if="emptyHistoryFlag==true">
                                    <td colspan="11" class="tableLinerB" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="pa2 my-5">
                            <div>
                                <div class="text-center" v-if="emptyHistoryFlag==false">
                                    <v-pagination
                                    v-model="page"
                                    :length="pagelength"
                                    ></v-pagination>
                                </div>
                            </div>
                        </div>

                            <div class="d-flex justify-space-between dense pa-0">
                                <div class="pa2 " >
                                <v-btn dark class="backBtn px-5"  @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn v-if="DEL_FLAG=='Y'" dark class="deleteBtn ml-2 px-5" @click="delconfirm=true">Delete</v-btn>
                                <v-btn dark class="registerBtn ml-2 px-6" @click="editInfo()">Edit</v-btn>
                            </div>
                            </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <div class="text-center pb-0 mb-0" >
            <v-form ref="form" v-model="formValid" lazy-validation >
                <v-dialog v-model="historyRegFlag" width="400">
                    <v-card>
                        <v-card-title class="text-subtitle-1 pb-3">
                            <span>History Register</span>
                        </v-card-title>
                        <v-card-text class="pb-0">
                            <v-simple-table>
                                <tbody>
                                    <tr>
                                        <th class="listHeader2 tableLinerT tableLinerB text-center" style="width:40%;height:40px !important;">User</th>
                                        <td class="tableLinerT text-left pl-5" style="height:40px !important;">{{loginInfo1}}</td>
                                    </tr>
                                    <tr>
                                        <th class="listHeader2 tableLinerT tableLinerB text-center" style="height:40px !important;">Registration Date</th>
                                        <td class="text-left pl-5" style="height:30px !important;">{{today}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class=" tableLinerB">
                                            <v-textarea
                                            outlined
                                            v-model="histroyCont"
                                            :rules="historyContRules"
                                            class="py-5"
                                            :counter="max"
                                            no-resize
                                            required
                                            ></v-textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                        <v-card-actions class="justify-end py-5 pr-10">
                            <v-btn class="cancelBtn" dark @click="closeHistoryDialog">cancel</v-btn>
                            <v-btn class="registerBtn" dark  @click="addHistory()">save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-form>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goBack">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--confirm delete-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="delconfirm" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-help-circle </v-icon>
                        <span class="pl-3">Do you want to delete vehicle?</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn class="deleteBtn" text dark @click="delconfirm=false">no</v-btn>
                        <v-btn class="registerBtn" text dark  @click="delInfo">yes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'VehicleDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"1", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Vehicle', disabled: true,}, { text: 'Vehicle List', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [
              {
                items: [
                  { title: 'Vehicle List', nums:11, href:'/Vehicle', icons:'mdi-format-list-bulleted' },
                  { title: 'New Registration', nums:12, href:'/VehicleWrite', icons:'mdi-lead-pencil' },
                ],
                title: 'Vehicle Management', nums: '1'
              },
              {
                items: [
                  { title: 'Contract List',nums:21, href:'/VehicleRLS', icons:'mdi-format-list-bulleted' },
                  { title: 'New Contract Registration', nums:22, href:'/VehicleRLS2', icons:'mdi-lead-pencil' },
                ],
                title: 'Contract Management', nums: '2'
              },
            ],   
            schEbkSeq:'',
            EBK_SEQ: "", NAT_NAME_KR: "",FAC_NAME_KR: "",EBK_MODEL_NAME: "",EBK_IDTFY_NUMS: "",
            VCU_ID: "",MCU_ID: "",CELL_ID1: "",CELL_ID2: "",APRV_STATUS: "",INS_DTM: "",INS_USR_ID: "",INS_USR: "",
            CONT1:"", CONT2:"", CONT3:"", CONT4:"",
            APRV_USR_ID: "",APRV_USR: "",APRV_DTM: "", APRV_INFO:"", DEL_FLAG:"N",
            page:1, pagelength:1,
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            today: new Date().toISOString().substr(0, 10),
            histroyCont:"",
            emptyFlag:true,emptyHistoryFlag:true,historyRegFlag:false, historyList:[],
            historyContRules: [
                v => !!v || 'content is required',
                v => v.length <= 100 || 'content must be less than 100 characters',
            ],
            max:100, formValid:false, asyncResult:0, delconfirm:false
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.ebkSeq);
        this.schEbkSeq = this.$route.params.ebkSeq;
        if(this.schEbkSeq != '') {
            this.getInfo();
            this.getHistory();
        }
        window.scrollTo(0, 0);
    },

    methods : {
    
        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "ebkSeq": this.schEbkSeq
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/eBike.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.EBK_SEQ = json.EBK_SEQ; this.NAT_NAME_KR = json.NAT_NAME_KR; this.FAC_NAME_KR = json.FAC_NAME_KR; 
                    this.EBK_MODEL_NAME = json.EBK_MODEL_NAME; this.EBK_IDTFY_NUMS = json.EBK_IDTFY_NUMS;
                    this.VCU_ID = json.VCU_ID; this.MCU_ID = json.MCU_ID; this.CELL_ID1 = json.CELL_ID1; this.CELL_ID2 = json.CELL_ID2; 
                    this.APRV_STATUS = json.APRV_STATUS;
                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; this.APRV_DTM = json.APRV_DTM;
                    this.CONT1 = json.CONT1; this.CONT2 = json.CONT2; this.CONT3 = json.CONT3; this.CONT4 = json.CONT4; this.APRV_INFO = json.APRV_INFO;
                    this.DEL_FLAG = json.DEL_FLAG;
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
        
        regOpenHistory() {
            this.histroyCont = "";
            this.historyRegFlag = true;
        },

        getHistory() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "dvcSeq": this.schEbkSeq
                    , "dvcType": 5
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.historyList = json.list;
              
                    this.emptyHistoryFlag = false;
                } else {
                   this.historyList = [];
                    this.emptyHistoryFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        addHistory() {
            this.validate();
            if( this.histroyCont == "" || this.histroyCont < 10 || this.histroyCont.length > 100 ) {
                alert('Please enter more than 10 characters and less than 100 characters');
                this.formValid = false;
            }
            //console.log(this.formValid);
            
            if(this.formValid === true) {
                var  requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "C"
                        , "dvcSeq": this.schEbkSeq
                        , "cont": this.histroyCont
                        , "dvcType": 5
                    })
                };
                
                fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json.result );
                    if(json.result == "success") {
                        this.getHistory();
                        this.histroyCont = '';
                        this.historyRegFlag = false;
                    } 
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            } else {
                this.resetValidation();
            }
            
        },

        validate () {
            this.$refs.form.validate();
        },

        resetValidation () {
            this.$refs.form.resetValidation();
        },

        closeHistoryDialog() {
            this.histroyCont = "";
            this.historyRegFlag = false;
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.histroyCont = "";
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Vehicle'});
        },

        editInfo() {
            this.$router.push({ name: 'VehicleWrite', params: { ebkSeq: this.schEbkSeq }})
        },

        delInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "D"
                    , "ebkSeq": this.schEbkSeq
                    
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/eBike.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.delconfirm = false;
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncResult = 1;
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
                //console.log("asyncResult: "+this.asyncResult);
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        }

    }

}
</script>
